module.exports = __webpack_public_path__ + "static/img/3408_phase_function_Paper_PointsHejduk_Prediction.c90ffac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3408_phase_function_Paper_PointsHejduk_Prediction.png
// module id = uAaH
// module chunks = 0